module.exports = __webpack_public_path__ + "static/img/videobtn.b4a68f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videobtn.png
// module id = RxS9
// module chunks = 60